import { render, staticRenderFns } from "./WorkspaceAreaRight.vue?vue&type=template&id=5406c78a&scoped=true&"
import script from "./WorkspaceAreaRight.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAreaRight.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAreaRight.vue?vue&type=style&index=0&id=5406c78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406c78a",
  null
  
)

export default component.exports